import React from 'react';
import urls, { codeUrl } from '@/constants/urls';
import CreatedWithUrlToast from '@/components/toasts/CreatedWithUrlToast';

const RoleCreatedToast = ({ name, code }) => (
  <CreatedWithUrlToast
    className="aridhia-role-created-toast"
    messageId="toast.your.role"
    name={name}
    url={codeUrl(urls.ROLES, code)}
  />
);

export default RoleCreatedToast;
